import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { isAnObject } from '../../../../components/Form/validations';
import SearchBarSingle from '../../../../components/SearchBarV3/SearchBarSingle';
import { BLACK } from '../../../../theme/colorConstants';
import { minutesFromMidnightToReadableTime } from '../../../../utils';
import { TIME_FIELDS_ERRORS } from '../../constDicts';
import { customShift, getAllValidShiftTimes, shiftTimeValidation } from '../../helpers';

export const corporationField = (value) => ({
  ComponentType: SearchBarSingle,
  preDefinedOptions: [],
  data: null,
  key: 'id',
  name: 'corporation',
  testId: 'corporation',
  required: true,
  variant: 'standard',
  optionLabel: 'name',
  placeholder: 'Corporation',
  fullWidth: true,
  onSubmitApiCallData: {
    httpMethod: 'POST',
    route: 'corporations/read',
  },
  optionDisplayField: 'name',
  validate: isAnObject(value),
});

export const positionTemplateField = ({ corporationId, value }) => ({
  ComponentType: SearchBarSingle,
  preDefinedOptions: [],
  data: {
    filters: [
      {
        field: 'corporation._id',
        value: corporationId,
        operation: 'equalsID',
      },
      {
        field: 'approved',
        value: true,
        operation: 'equals',
      },
    ],
  },
  name: 'positionTemplate',
  testId: 'positionTemplate',
  required: true,
  variant: 'standard',
  optionLabel: 'name',
  placeholder: 'Position',
  fullWidth: true,
  onSubmitApiCallData: {
    httpMethod: 'POST',
    route: 'position-templates/read',
  },
  optionDisplayField: 'name',
  disabled: !corporationId,
  validate: isAnObject(value),
});

export const locationField = ({ positionTemplate, value }) => {
  const locations = positionTemplate?.locations.map((location) => ({
    address: location.address,
    _id: location._id,
    description: location.description,
  }));

  return {
    ComponentType: SearchBarSingle,
    dropDownOptions: locations || [],
    data: null,
    name: 'location',
    testId: 'location',
    required: true,
    variant: 'standard',
    optionLabel: 'name',
    placeholder: 'Location',
    fullWidth: true,
    optionDisplayField: 'description',
    disabled: !positionTemplate,
    validate: isAnObject(value),
  };
};

export const departmentField = ({ positionTemplate, value }) => ({
  ComponentType: SearchBarSingle,
  dropDownOptions: positionTemplate?.departments || [],
  data: null,
  name: 'department',
  testId: 'department',
  required: true,
  variant: 'standard',
  optionLabel: 'name',
  placeholder: 'Department',
  fullWidth: true,
  optionDisplayField: 'name',
  disabled: !positionTemplate,
  validate: isAnObject(value),
});

const reformatShifts = (shifts) =>
  shifts.map((shift) => {
    if (shift?.name === customShift?.name) {
      return {
        ...shift,
        displayLabel: LanguageConverter('job.create.shift.custom'),
      };
    }

    return {
      ...shift,
      displayLabel: `${minutesFromMidnightToReadableTime(
        shift?.start
      )} - ${minutesFromMidnightToReadableTime(shift?.end)}`,
    };
  });

export const shiftField = ({ positionTemplate, value }) => ({
  ComponentType: SearchBarSingle,
  dropDownOptions: reformatShifts([...(positionTemplate?.shifts || []), customShift]),
  data: null,
  name: 'shift',
  testId: 'shift',
  required: true,
  variant: 'standard',
  optionLabel: 'displayLabel',
  placeholder: 'Shift',
  sx: {
    minWidth: '220px',
    maxWidth: '308px',
  },
  optionDisplayField: 'displayLabel',
  validate: isAnObject(value),
});

export const startTimeField2 = ({ sx, shouldErrorColor }) => ({
  ComponentType: SearchBarSingle,
  dropDownOptions: getAllValidShiftTimes(),
  data: null,
  name: 'startTime',
  testId: 'startTime',
  required: true,
  variant: 'standard',
  optionLabel: 'displayLabel',
  placeholder: 'Start',
  sx: {
    minWidth: '150px',
    ...(sx || {}),
  },
  optionDisplayField: 'displayLabel',
  EndIcon: AccessTimeIcon,
  customIconColor: BLACK[80],
  validate: (val, formVals) => shiftTimeValidation(val, formVals),
  shouldErrorColor,
  errorsToHideText: Object.values(TIME_FIELDS_ERRORS),
});

export const endTimeField2 = ({ sx, shouldErrorColor }) => ({
  ComponentType: SearchBarSingle,
  dropDownOptions: getAllValidShiftTimes(),
  data: null,
  name: 'endTime',
  testId: 'endTime',
  required: true,
  variant: 'standard',
  optionLabel: 'displayLabel',
  placeholder: 'End',
  sx: {
    minWidth: '150px',
    ...(sx || {}),
  },
  optionDisplayField: 'displayLabel',
  validate: (val, formVals) => shiftTimeValidation(val, formVals),
  EndIcon: AccessTimeIcon,
  customIconColor: BLACK[80],
  shouldErrorColor,
  errorsToHideText: Object.values(TIME_FIELDS_ERRORS),
});
